import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as firebase from 'firebase/app';
import { AngularFireAuth, PERSISTENCE } from '@angular/fire/auth';

import { CarouselConfig } from 'ngx-bootstrap/carousel';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 3000, noPause: false, showIndicators: false } }
  ]
})
export class LandingComponent implements OnInit {

  constructor(private afAuth: AngularFireAuth,private router: Router) { }

  ngOnInit() {
    this.afAuth.onAuthStateChanged((user)=>{
      if (user) {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.router.navigate(['/projects']);
      }
    })
    
  }

}
